import { useState } from "react";
import { ToolbarProps, View } from "react-big-calendar";
import clsx from "clsx";
import { CALENDAR_VIEW_LABEL } from "../../../constants";
import { CALENDAR_VIEW_TYPE, CalendarViewType } from "../../../types/account/enum";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "../../atom/Dropdown/Dropdown";

import { CheckIcon } from "../../../icons";
import { usePreference } from "../../../hooks/preference/usePreference";

const CalendarViewButton = ({ toolbar }: { toolbar: ToolbarProps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { updatePreference } = usePreference();

  const { view } = toolbar;

  const setView = (type: View) => {
    toolbar.onView(type);
    updatePreference({ calendarViewType: type as CalendarViewType });
  };

  return (
    <DropdownMenu
      modal={false}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <DropdownMenuTrigger asChild>
        <button
          className={clsx(
            "w-fit px-2 h-8 gap-[15px] flex flex-row flex-nowrap justify-center items-center text-sm font-normal leading-[38px] select-none text-80 cursor-pointer rounded-[5px] bg-transparent",
            "hover:bg-w-8-hover hover:text-white",
            { "bg-w-8-hover text-white": isOpen }
          )}
        >
          {CALENDAR_VIEW_LABEL[view as keyof typeof CALENDAR_VIEW_LABEL]}
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        width="140px"
        sideOffset={5}
        align="end"
        className="w-[170px] text-white"
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <DropdownMenuRadioGroup
          value={view}
          onValueChange={(value) => setView(value as View)}
        >
          {Object.values(CALENDAR_VIEW_TYPE).map((viewType) => {
            return (
              <DropdownMenuRadioItem
                key={viewType}
                value={viewType}
                className={clsx(
                  "flex cursor-pointer w-full h-8 px-2 box-border items-center justify-between gap-[6px] text-80 data-[highlighted]:outline-none data-[highlighted]:bg-w-8-hover hover:text-white text-[12px]",
                  { "text-moba hover:text-moba": view === viewType }
                )}
              >
                <p>{CALENDAR_VIEW_LABEL[viewType]}</p>
                {view === viewType && <CheckIcon color={"#69E4FF"} />}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CalendarViewButton;
